"use client";

import { useEffect, useState } from "react";
import { useAutumnContext } from "../AutumnContext";
import { getPricingTableAction } from "../../server/componentActions";
const mergeProductDetails = (products, productDetails) => {
  if (!products) {
    return null;
  }
  if (!productDetails) {
    return products;
  }
  let mergedProducts = structuredClone(products);
  for (const product of productDetails) {
    let index = mergedProducts.findIndex((p) => p.id === product.id);
    if (index == -1) {
      console.warn(`Product with id ${product.id} not found`);
      continue;
    }
    mergedProducts[index] = {
      ...mergedProducts[index],
      ...product
    };
  }
  return mergedProducts;
};
const usePricingTable = (options) => {
  const { encryptedCustomerId } = useAutumnContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState(null);
  const fetchProducts = async () => {
    let returnData = null;
    try {
      setIsLoading(true);
      const res = await getPricingTableAction({
        encryptedCustomerId
      });
      if (res.error) {
        setError(res.error);
        return res;
      }
      let products2 = res.data.list;
      setProducts(products2);
      returnData = products2;
    } catch (error2) {
      setError(error2);
    } finally {
      setIsLoading(false);
    }
    return returnData;
  };
  useEffect(() => {
    fetchProducts();
  }, []);
  return {
    products: mergeProductDetails(products, options?.productDetails),
    isLoading,
    error,
    refetch: fetchProducts
  };
};
export {
  usePricingTable
};
